var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBolt = function SvgBolt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -4.93,
    y1: 40.73,
    x2: 166.15,
    y2: 174.12,
    gradientTransform: "translate(0 200) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M156.4,68.09c-.55-1.17-1.72-1.93-3.02-1.93h-39.5L152.87,4.62c.65-1.03.69-2.33.1-3.39-.59-1.07-1.71-1.73-2.92-1.73h-53.33c-1.26,0-2.42.71-2.98,1.84l-50,100c-.52,1.03-.46,2.26.15,3.24.61.98,1.68,1.58,2.84,1.58h34.28l-37.35,88.71c-.64,1.52-.07,3.28,1.33,4.14.54.33,1.14.49,1.74.49.96,0,1.9-.41,2.55-1.18l106.67-126.67c.84-.99,1.02-2.38.47-3.56h-.02Z",
    style: {
      fill: "url(#b)",
      strokeWidth: 0
    }
  }));
};
export default SvgBolt;